import { z } from "zod";

export const securitySchema = z
	.object({
		current_password: z
			.string()
			.min(1, "Current password is required"),

		password: z
			.string()
			.min(8, "Password must be at least 8 characters")
			.regex(/[A-Z]/, "Password must contain at least one uppercase letter")
			.regex(/[a-z]/, "Password must contain at least one lowercase letter")
			.regex(/[0-9]/, "Password must contain at least one number")
			.regex(/[@$!%*?&#^()\-_=+{}[\]|\\:;"'<>,.?/]/,
				"Password must contain at least one special character"),

		password_confirmation: z
			.string()
			.min(1, "Please confirm your new password"),
	})
	.superRefine((data, ctx) => {
		// Prevent reusing same password
		if (data.current_password === data.password) {
			ctx.addIssue({
				path: ["password"],
				message: "New password must be different from current password",
				code: z.ZodIssueCode.custom,
			});
		}

		// Confirm password match
		if (data.password !== data.password_confirmation) {
			ctx.addIssue({
				path: ["password_confirmation"],
				message: "Passwords do not match",
				code: z.ZodIssueCode.custom,
			});
		}
	});
